import React from 'react'

export default function Friend({handle}) {
    return (
        <div className="container"> 
        
            <h3>{handle}</h3> 
            <a href={`http://codeforces.com/profile/${handle}`} target='_blank'><i class="material-icons" >launch</i></a>
        </div>
    )
}
